module.exports = __webpack_public_path__ + "img/illustration-verifyEmail.b6f0f5a8.svg";